module.exports = __webpack_public_path__ + "img/1.0ea27969.png";